import templateUrl from 'emun.customer/customer-quarterly-sales-source.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import salesrepConfig from 'emun.salesrep/salesrep.config'

class CustomerQuarterlySalesSourceController {
    constructor($rootScope, createAutoQuery) { 
        let $ctrl = this;
        basicController($ctrl);
        this.sourceChartLabels = ['Jan-Mar', 'Apr-Jun', 'Jul-Sep', 'Oct-Dec'];
        this.sourceChartSeries = [];
		$ctrl.colors = salesrepConfig.chartColors;
        $ctrl.chartOptions = {
            maintainAspectRatio: false,
            legend: {
                display: true,
                labels: {
                    boxWidth: 5,
                    fontSize: 10
                }
            },
            elements: {
                rectangle: {
                    borderWidth: 1
                }
            },
            scales: {
                yAxes: [{
                    display: true,
                    ticks: {
                        callback: function (value, index, values) {
                            return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        },
                        fontSize: 11
                    }
                }]
            },
            tooltips: {
                enabled: true,
                callbacks: {
                    label: function (tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label;
                        var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        //                        return label + ': ' + $filter('currency')(datasetLabel);
                    }
                }
            },
        }

        $ctrl.sourceChartData = [];
        var today = new Date();
        $ctrl.loadSourceChartData = function (args) {
            this.sourceChartLabels = ['Jan-Mar', 'Apr-Jun', 'Jul-Sep', 'Oct-Dec'];
            this.sourceChartSeries = [];
            this.sourceChartData = [];
            let $ctrl = this;
            var flags = [];
            args.forEach(function (obj) {
                if (!flags[obj.source]) {
                    flags[obj.source] = true;
                    $ctrl.sourceChartSeries.push(obj.source);
                }
            });
            $ctrl.sourceChartSeries.forEach(function (series) {
                var result = args.filter(function (obj) {
                    return obj.source == series;
                });
                var sourceSeriesData = [0, 0, 0, 0];
                result.forEach(function (obj) {
                    sourceSeriesData[obj.quarter - 1] = Math.round(obj.total);
                });
                $ctrl.sourceChartData.push(sourceSeriesData);
                $ctrl.chartLoaded = true;
            });
        }

        var url = 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal&GroupBy=Source,Quarter&dateRange=YTD&CustomerID=' + $ctrl.customerId;
        var quarterlySales = createAutoQuery({
            url: url,
            autoLoad: true,
            pageSize: 1000,
            onLoaded: function (args) {
                var results = [];
                args.results.forEach(function (res) {
                    var obj = {
                        total: 0,
                        source: '',
                        quarter: 0
                    };
                    obj.source = res.source;
                    obj.total += res.sumSalesDailyTotal;
                    obj.quarter = res.quarter;
                    results.push(obj);
                });
				$ctrl.chartLoaded = true;
                $ctrl.loadSourceChartData(results);
            }
        });
    }
    loadChartData(args){
        const $ctrl = this;
        $ctrl.chartSeries = [];
        $ctrl.chartData = [];
        let flags = [];
        args.forEach(function(obj) {
            if(!flags[obj.source]) {
                flags[obj.source] = true;
                $ctrl.chartSeries.push(obj.source);
            }
        });
        $ctrl.chartSeries.forEach(function(series) {
            let result = args.filter(function( obj ) {
                return obj.source == series;
            });
            let seriesData = [0,0,0,0];
            result.forEach(function(obj) {
                seriesData[obj.quarter - 1] = Math.round(obj.total);
            });
            $ctrl.chartData.push(seriesData);
        });
    }
}

let CustomerQuarterlySalesSource = {
    bindings: {
        customer: '<'
    },
    controller: CustomerQuarterlySalesSourceController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default CustomerQuarterlySalesSource